export default __webpack_public_path__ + "static/media/ante-reviewed.51370c1f.svg";